/**
 * Cucù Boutique — Premium Theme JS
 * Preloader, cursor, scroll reveal, AJAX cart, quick-add, counters
 */
(function () {
  'use strict';

  const isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reduceMotion  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- PRELOADER ---------- */
  function initPreloader() {
    const el = document.getElementById('cucuPreloader');
    if (!el) return;
    setTimeout(() => {
      el.classList.add('is-hidden');
      setTimeout(() => el.remove(), 900);
    }, 1100);
  }

  /* ---------- CUSTOM CURSOR ---------- */
  function initCursor() {
    if (!isFinePointer) return;
    const dot = document.querySelector('.cucu-cursor-dot');
    const out = document.querySelector('.cucu-cursor-outline');
    if (!dot || !out) return;

    let mx = 0, my = 0, ox = 0, oy = 0;
    window.addEventListener('mousemove', (e) => {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate(' + (mx - 4) + 'px, ' + (my - 4) + 'px)';
    });
    (function loop() {
      ox += (mx - ox) * 0.18;
      oy += (my - oy) * 0.18;
      out.style.transform = 'translate(' + (ox - 18) + 'px, ' + (oy - 18) + 'px)';
      requestAnimationFrame(loop);
    })();

    const hoverSel = 'a, button, [role="button"], label, input, select, textarea, .cucu-card, .cucu-hotspot';
    document.addEventListener('mouseover', (e) => { if (e.target.closest(hoverSel)) document.body.classList.add('cucu-hovering'); });
    document.addEventListener('mouseout',  (e) => { if (e.target.closest(hoverSel)) document.body.classList.remove('cucu-hovering'); });
  }

  /* ---------- SCROLL REVEAL ---------- */
  function initReveal() {
    if (reduceMotion) {
      document.querySelectorAll('.cucu-reveal').forEach(el => el.classList.add('is-visible'));
      return;
    }
    const els = document.querySelectorAll('.cucu-reveal');
    if (!els.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(el => io.observe(el));
  }

  /* ---------- NUMBER TICKER ---------- */
  function initCounters() {
    const counters = document.querySelectorAll('[data-cucu-counter]');
    if (!counters.length) return;

    const animate = (el) => {
      const target = parseFloat(el.dataset.cucuCounter);
      const dur = parseInt(el.dataset.cucuCounterDuration, 10) || 2000;
      const dec = parseInt(el.dataset.cucuCounterDecimals, 10) || 0;
      if (reduceMotion) { el.textContent = target.toFixed(dec); return; }
      const start = performance.now();
      (function step(now) {
        const p = Math.min((now - start) / dur, 1);
        const e = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * e).toFixed(dec);
        if (p < 1) requestAnimationFrame(step);
      })(start);
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { animate(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach(el => io.observe(el));
  }

  /* ---------- ANNOUNCEMENT ROTATION ---------- */
  function initAnnounce() {
    const tracks = document.querySelectorAll('[data-cucu-announce]');
    tracks.forEach((track) => {
      const slides = track.querySelectorAll('.cucu-announce__slide');
      if (slides.length < 2) return;
      const speed = parseInt(track.dataset.cucuAnnounce, 10) || 5000;
      let i = 0;
      slides[0].classList.add('is-active');
      setInterval(() => {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- PREMIUM MOTION ---------- */
  function initPremiumMotion() {
    if (!isFinePointer || reduceMotion) return;

    document.querySelectorAll('.cucu-btn').forEach((btn) => {
      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width - 0.5) * 8;
        const y = ((e.clientY - r.top) / r.height - 0.5) * 8;
        btn.style.setProperty('--cucu-mx', x.toFixed(2) + 'px');
        btn.style.setProperty('--cucu-my', y.toFixed(2) + 'px');
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.setProperty('--cucu-mx', '0px');
        btn.style.setProperty('--cucu-my', '0px');
      });
    });

    const tiltTargets = document.querySelectorAll('.cucu-card__media, .cucu-hero__media, .cucu-look__item');
    tiltTargets.forEach((el) => {
      el.addEventListener('mousemove', (e) => {
        const r = el.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width;
        const py = (e.clientY - r.top) / r.height;
        const ry = (px - 0.5) * 7;
        const rx = (0.5 - py) * 7;
        el.style.setProperty('--cucu-rx', rx.toFixed(2) + 'deg');
        el.style.setProperty('--cucu-ry', ry.toFixed(2) + 'deg');
        el.style.setProperty('--cucu-sx', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--cucu-sy', (py * 100).toFixed(1) + '%');
      });
      el.addEventListener('mouseleave', () => {
        el.style.setProperty('--cucu-rx', '0deg');
        el.style.setProperty('--cucu-ry', '0deg');
        el.style.setProperty('--cucu-sx', '50%');
        el.style.setProperty('--cucu-sy', '35%');
      });
    });
  }

  /* ---------- WISHLIST ---------- */
  function initWishlist() {
    const key = 'cucu:wishlist';
    const drawer = document.getElementById('cucuWishlist');
    const body = drawer ? drawer.querySelector('[data-cucu-wishlist-body]') : null;
    const escapeHTML = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
    const read = () => {
      try { return JSON.parse(localStorage.getItem(key) || '[]'); }
      catch (err) { return []; }
    };
    const renderDrawer = (items) => {
      if (!body) return;
      if (!items.length) {
        body.innerHTML = '<p class="cucu-wishlist-drawer__empty">Non hai ancora aggiunto prodotti ai preferiti.</p>';
        return;
      }
      body.innerHTML = items.map((item) => ''
        + '<div class="cucu-wishlist-drawer__item" data-handle="' + escapeHTML(item.handle) + '">'
        + '<a href="' + escapeHTML(item.url) + '">' + escapeHTML(item.title) + '</a>'
        + '<button type="button" data-cucu-wishlist-remove="' + escapeHTML(item.handle) + '">Rimuovi</button>'
        + '</div>'
      ).join('');
    };
    const write = (items) => {
      localStorage.setItem(key, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('cucu:wishlist:update', { detail: { items: items } }));
    };
    const sync = () => {
      const handles = read().map((item) => item.handle);
      document.querySelectorAll('[data-cucu-wishlist]').forEach((btn) => {
        const active = handles.includes(btn.dataset.productHandle);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        const icon = btn.querySelector('[aria-hidden="true"]');
        if (icon) icon.textContent = active ? '♥' : '♡';
      });
      document.querySelectorAll('[data-cucu-wishlist-count]').forEach((el) => {
        el.textContent = handles.length;
        el.hidden = handles.length === 0;
      });
      renderDrawer(read());
    };

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cucu-wishlist]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.dataset.productHandle;
      if (!handle) return;
      const items = read();
      const exists = items.some((item) => item.handle === handle);
      const next = exists
        ? items.filter((item) => item.handle !== handle)
        : items.concat([{
            handle: handle,
            title: btn.dataset.productTitle || handle,
            url: btn.dataset.productUrl || '#'
          }]);
      write(next);
      sync();
    });

    document.addEventListener('cucu:wishlist:update', sync);
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-cucu-wishlist-toggle]');
      if (toggle && drawer) {
        e.preventDefault();
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cucu-no-scroll');
      }
      if (e.target.closest('[data-cucu-wishlist-close]') && drawer) {
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('cucu-no-scroll');
      }
      const remove = e.target.closest('[data-cucu-wishlist-remove]');
      if (remove) {
        const next = read().filter((item) => item.handle !== remove.dataset.cucuWishlistRemove);
        write(next);
        sync();
      }
    });
    sync();
  }

  /* ---------- DEAL COUNTDOWN ---------- */
  function initDealCountdowns() {
    document.querySelectorAll('[data-cucu-deals]').forEach((root) => {
      const deadlineRaw = root.dataset.deadline;
      const deadline = deadlineRaw ? new Date(deadlineRaw) : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
      const days = root.querySelector('[data-cucu-days]');
      const hours = root.querySelector('[data-cucu-hours]');
      const minutes = root.querySelector('[data-cucu-minutes]');
      const seconds = root.querySelector('[data-cucu-seconds]');
      if (!days || !hours || !minutes || !seconds) return;

      const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
      const tick = () => {
        const diff = Math.max(0, deadline.getTime() - Date.now());
        const d = Math.floor(diff / 86400000);
        const h = Math.floor(diff / 3600000) % 24;
        const m = Math.floor(diff / 60000) % 60;
        const s = Math.floor(diff / 1000) % 60;
        days.textContent = pad(d);
        hours.textContent = pad(h);
        minutes.textContent = pad(m);
        seconds.textContent = pad(s);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- AJAX CART ---------- */
  const cart = {
    drawer: null, body: null, foot: null,
    money(c) { return '€ ' + (c/100).toLocaleString('it-IT', { minimumFractionDigits: 2 }); },
    escapeHTML(value) {
      return String(value ?? '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char]));
    },
    open() { if (this.drawer) { this.drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('cucu-no-scroll'); } },
    close() { if (this.drawer) { this.drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('cucu-no-scroll'); } },
    async fetchCart() { return (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); },
    async add(id, q) {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: q || 1 })
      });
      if (!r.ok) { const err = await r.json().catch(() => ({})); throw new Error(err.description || 'Errore'); }
      return r.json();
    },
    async change(line, q) {
      return (await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: q })
      })).json();
    },
    render(c) {
      if (!this.body) return;
      if (c.item_count === 0) {
        this.body.innerHTML = '<p class="cucu-cart__empty">Carrello vuoto</p>';
        if (this.foot) this.foot.hidden = true;
      } else {
        this.body.innerHTML = c.items.map((it, i) => this.itemHTML(it, i+1)).join('');
        if (this.foot) {
          this.foot.hidden = false;
          const s = this.foot.querySelector('[data-cucu-subtotal]');
          if (s) s.textContent = this.money(c.total_price);
        }
      }
      document.querySelectorAll('[data-cucu-cart-count]').forEach(el => { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
    },
    itemHTML(it, line) {
      const title = this.escapeHTML(it.product_title || it.title || '');
      const fullTitle = this.escapeHTML(it.title || '');
      const url = this.escapeHTML(it.url || '#');
      const variantTitle = this.escapeHTML(it.variant_title || '');
      const img = it.featured_image && it.featured_image.url
        ? '<img class="cucu-cart__img" src="' + this.escapeHTML(it.featured_image.url) + '&width=160" alt="' + fullTitle + '">'
        : '<div class="cucu-cart__img"></div>';
      const variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="cucu-cart__variant">' + variantTitle + '</p>' : '';
      return ''
        + '<div class="cucu-cart__item" data-line="' + line + '">'
        + img
        + '<div class="cucu-cart__info">'
        +   '<h3 class="cucu-cart__product"><a href="' + url + '">' + title + '</a></h3>'
        +   variant
        +   '<p class="cucu-cart__price">' + this.money(it.final_line_price) + '</p>'
        +   '<div class="cucu-cart__qty">'
        +     '<button type="button" data-cucu-dec aria-label="Diminuisci">−</button>'
        +     '<input type="text" value="' + it.quantity + '" readonly>'
        +     '<button type="button" data-cucu-inc aria-label="Aumenta">+</button>'
        +   '</div>'
        + '</div>'
        + '<button type="button" class="cucu-cart__remove" data-cucu-remove>Rimuovi</button>'
        + '</div>';
    },
    bindLines() {
      this.body.addEventListener('click', async (e) => {
        const row = e.target.closest('.cucu-cart__item');
        if (!row) return;
        const line = parseInt(row.dataset.line, 10);
        const qty  = parseInt(row.querySelector('input').value, 10);
        if (e.target.matches('[data-cucu-inc]'))    this.render(await this.change(line, qty + 1));
        else if (e.target.matches('[data-cucu-dec]')) this.render(await this.change(line, Math.max(0, qty - 1)));
        else if (e.target.matches('[data-cucu-remove]')) this.render(await this.change(line, 0));
      });
    },
    async refresh() {
      const c = await this.fetchCart();
      this.render(c);
      // Notify Shopify apps (reviews, upsell, cart widgets) of cart change
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: c }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: c } }));
      if (window.Shopify && window.Shopify.PubSub && typeof window.Shopify.PubSub.publish === 'function') {
        window.Shopify.PubSub.publish('cart:update', { cart: c });
      }
      return c;
    }
  };
  window.cucuCart = cart;

  function initCart() {
    cart.drawer = document.getElementById('cucuCart');
    if (!cart.drawer) return;
    cart.body = cart.drawer.querySelector('[data-cucu-body]');
    cart.foot = cart.drawer.querySelector('[data-cucu-foot]');

    cart.drawer.querySelectorAll('[data-cucu-close]').forEach(el => el.addEventListener('click', () => cart.close()));
    cart.bindLines();
    cart.refresh();

    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-cucu-cart-toggle], cart-icon, .header-actions__cart-icon, a[href="/cart"], a[href$="/cart"]');
      if (t) { e.preventDefault(); e.stopPropagation(); cart.open(); }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') cart.close(); });
  }

  /* ---------- QUICK ADD ---------- */
  function initQuickAdd() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cucu-add]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      const id = btn.dataset.variantId;
      if (!id) return;

      const original = btn.textContent;
      btn.disabled = true; btn.textContent = 'Aggiungo...';
      try {
        await cart.add(id, 1);
        await cart.refresh();
        cart.open();
        btn.textContent = '✓ Aggiunto';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
      } catch (err) {
        btn.textContent = 'Errore';
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
      }
    });
  }

  /* ---------- INIT ---------- */
  function init() {
    initPreloader();
    initCursor();
    initReveal();
    initCounters();
    initAnnounce();
    initPremiumMotion();
    initWishlist();
    initDealCountdowns();
    initCart();
    initQuickAdd();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      initReveal();
      initCounters();
      initAnnounce();
      initPremiumMotion();
      initWishlist();
      initDealCountdowns();
    });
  }
})();
